import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { Button, IconButton } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';

import Documents from 'views/Documents';
import DocumentViewer from 'views/Projects/components/ModelViewer/DocumentViewer';
import api from 'utils/api';
import { blobToFileDownload, toast } from 'utils/helpers';

const DocumentShow = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id: documentId } = useParams();

  const [document, setDocument] = useState(null);


  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const response = await api.get(`/documents/${documentId}`);
        setDocument(response.data);
      } catch (error) {
        // Handle error appropriately
        console.error('Error fetching document:', error);
      }
    }
    fetchDocument();
  }, []);

  const handleDownloadClick = async () => {
    const { data } = await api.get(`/documents/${document?._id}/contents`, { responseType: 'arraybuffer' });

    var bytes = new Uint8Array(data);
    const blob = new Blob([bytes], { type: document.contentType });

    blobToFileDownload(document.title, blob);
  };

  const handleDeleteClick = async () => {
    if (!window.confirm(t('Ar tikrai norite pašalinti dokumentą?'))) return;

    try {
      await api.delete(`/documents/${document?._id}`);
      toast(t('Pašalinta'), 'success');
      history.push('/documents');
    } catch (error) {
      console.error('Error deleting document:', error);
      toast(t('Nepavyko pašalinti'), 'error');
    }
  };

  const title = <>
    {document?.title || t('Dokumentas')}
    <Button
      variant="contained"
      color="primary"
      style={{ marginLeft: 10 }}
      size="small"
      onClick={handleDownloadClick}
    >
      {t('Atsisiųsti')}
    </Button>
    <Button
      variant="contained"
      color="primary"
      style={{ marginLeft: 10, background: 'red' }}
      size="small"
      onClick={handleDeleteClick}
    >
      {t('Pašalinti')}
    </Button>
  </>;

  return (
    <Documents
      title={title}
      // breadcrumbs={[
      //   { title: t('Dokumentai') }
      // ]}
      style={{ padding: 0 }}
    >
      {!!document && (
        <DocumentViewer
          documentIds={[document._id]}
          style={{
            width: '100%',
            height: 'calc(100vh - 70px)',
          }}
        />
      )}
    </Documents>
  );
}

export default DocumentShow;